module.exports = __webpack_public_path__ + "files/a6a3214c26a6bff9015df589f047fc4f.png";